import { FORM_TYPE } from '../forms'

export const isMultiPage = (form) => form?.form_type === FORM_TYPE.MULTI_PAGE

export const isSinglePage = (form) => form?.form_type === FORM_TYPE.SINGLE_PAGE
